<template>
    <div class="donation-ticker" :style="cssVars" v-if="donations.length">
        <div class="ticker-track">
            <!-- First set with tagline -->
            <div class="ticker-item tagline-item">
                <span class="star-icon">&#9733;</span>
                <span class="tagline-text">Successful students start here</span>
                <span class="star-icon">&#9733;</span>
                <span class="divider">|</span>
            </div>
            <div class="ticker-item" v-for="(donation, i) in donations" :key="'first-' + i">
                <span class="heart-icon">&#10084;</span>
                <span class="donor-name">{{ formatDonorName(donation) }}</span>
                <span class="amount">donated {{ formatAmount(donation.amount) }}</span>
                <span class="message" v-if="donation.donor_note">"{{ truncateNote(donation.donor_note) }}"</span>
                <span class="divider">|</span>
            </div>
            <!-- Second set (duplicate for seamless loop) with tagline -->
            <div class="ticker-item tagline-item">
                <span class="star-icon">&#9733;</span>
                <span class="tagline-text">Successful students start here</span>
                <span class="star-icon">&#9733;</span>
                <span class="divider">|</span>
            </div>
            <div class="ticker-item" v-for="(donation, i) in donations" :key="'second-' + i">
                <span class="heart-icon">&#10084;</span>
                <span class="donor-name">{{ formatDonorName(donation) }}</span>
                <span class="amount">donated {{ formatAmount(donation.amount) }}</span>
                <span class="message" v-if="donation.donor_note">"{{ truncateNote(donation.donor_note) }}"</span>
                <span class="divider">|</span>
            </div>
        </div>
    </div>
</template>

<script>
import DonationService from "../services/donation.service";

export default {
    name: 'DonationTicker',
    props: {
        maxDonations: {
            type: Number,
            default: 20
        },
        animationSpeed: {
            type: Number,
            default: 30
        },
        schoolId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            donations: [],
            calculatedSpeed: this.animationSpeed
        }
    },
    computed: {
        cssVars() {
            return {
                '--speed': this.calculatedSpeed + 's',
                '--count': this.donations.length
            }
        },
        duplicatedDonations() {
            return [...this.donations, ...this.donations];
        }
    },
    async beforeMount() {
        try {
            const donations = await DonationService.getRecentDonations(this.maxDonations, this.schoolId);
            this.donations = donations;
            this.calculatedSpeed = 15 + (5 * this.donations.length);
        } catch {
            this.donations = [];
        }
    },
    methods: {
        formatDonorName(donation) {
            if (donation.is_anonymous) {
                return 'Anonymous';
            }
            return donation.donor_name || 'Anonymous';
        },
        formatAmount(amountInCents) {
            const dollars = (amountInCents / 100).toFixed(0);
            return `$${dollars}`;
        },
        truncateNote(note) {
            if (!note) return '';
            const maxLength = 50;
            if (note.length <= maxLength) {
                return note;
            }
            return note.substring(0, maxLength) + '...';
        }
    }
}
</script>

<style scoped lang="scss">
.donation-ticker {
    padding: 15px 0;
    overflow: hidden;
    width: 100vw !important;
    height: 60px;
    margin: 0 auto;
    position: relative;
    display: flex;
    background: linear-gradient(90deg, #2D76E3 0%, #1a1a2e 100%);

    .ticker-track {
        display: flex;
        animation: marquee var(--speed) linear infinite;
        -webkit-animation: marquee-ios var(--speed) linear infinite;
    }

    &:hover .ticker-track {
        animation-play-state: paused;
    }

    .ticker-item {
        display: flex;
        align-items: center;
        white-space: nowrap;
        padding: 0 10px;
        color: #ffffff;
        font-family: 'Poppins', sans-serif;
        font-size: 14px;

        .heart-icon {
            color: #ff6b6b;
            margin-right: 8px;
            font-size: 16px;
        }

        .donor-name {
            font-weight: 600;
            margin-right: 6px;
        }

        .amount {
            color: #90EE90;
            font-weight: 500;
            margin-right: 8px;
        }

        .message {
            color: rgba(255, 255, 255, 0.85);
            font-style: italic;
            margin-right: 8px;
        }

        .divider {
            color: rgba(255, 255, 255, 0.4);
            margin: 0 15px;
        }

        &.tagline-item {
            background: rgba(255, 255, 255, 0.1);
            border-radius: 20px;
            padding: 4px 16px;
            margin: 0 10px;

            .star-icon {
                color: #FFD700;
                margin: 0 8px;
                font-size: 16px;
                text-shadow: 0 0 8px rgba(255, 215, 0, 0.5);
            }

            .tagline-text {
                font-weight: 700;
                font-size: 14px;
                text-transform: uppercase;
                letter-spacing: 1.5px;
                color: #ffffff;
            }
        }
    }

    @media (max-width: 768px) {
        height: 50px;
        padding: 12px 0;

        .ticker-item {
            font-size: 12px;

            .message {
                display: none;
            }

            .heart-icon {
                font-size: 14px;
            }
        }
    }
}

@keyframes marquee {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-50%);
    }
}

@-webkit-keyframes marquee-ios {
    0% {
        -webkit-transform: translateX(0);
    }
    100% {
        -webkit-transform: translateX(-50%);
    }
}
</style>
